module.exports = __webpack_public_path__ + "static/media/5-check.2410a5ef.svg";